import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./cta-button.module.css";
export var CtaButton = function(param) {
    var href = param.href, onClick = param.onClick, small = param.small, className = param.className, children = param.children;
    var _obj;
    var classNames = cx(styles.ctaButton, (_obj = {}, _define_property(_obj, "".concat(className), className), _define_property(_obj, styles.ctaButtonSmall, small), _obj));
    if (href) {
        return /*#__PURE__*/ _jsx("a", {
            href: href,
            onClick: onClick,
            className: classNames,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx("button", {
        onClick: onClick,
        className: classNames,
        children: children
    });
};
